import { handleRequestGet,handleRequestPost } from '../axios';
import { parseResult, queryParamStr, queryParamStrArr } from './GeneralFunc';

export const getPortfolio = async (acc_ids = null, { size = 10 }, page = 1) => {
    let url = '/client/portfolio?';
    let queryString = '';
    queryString += queryParamStr('size', size, true);
    queryString += queryParamStr('page', page);
    queryString += queryParamStrArr('accounts[]', acc_ids);

    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});

    // console.log('fullUrl', fullUrl);
    // console.log(result);

    return parseResult(result);
};

export const getPortfolioRealized = async (acc_id = [], { size = 10,stocks=[],exchanges=[] }, page = 1) => {
    // let url = '/client/account/'+acc_id+'/portfolio/realize?';
    let url = '/client/portfolio/realize?';

    let queryString = '';
    queryString += queryParamStr('size', size, true);
    queryString += queryParamStr('page', page);

    if(stocks && stocks.length >0){
        queryString += queryParamStrArr('stocks[]', stocks);
    }

    if(exchanges && exchanges.length >0){
        queryString += queryParamStrArr('exchanges[]', exchanges);
    }

    // if(acc_id){
    //     queryString += queryParamStr('accounts[]', acc_id);
    // }

    if(acc_id && acc_id.length >0){
        queryString += queryParamStrArr('accounts[]', acc_id);
    }


    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});

    // console.log('fullUrl', fullUrl);
    // console.log(result);

    return parseResult(result);
};

export const getPortfolioRealizedHistory = async (acc_id = null,ref=null, { size = 10 }, page = 1) => {
    let url = '/client/account/'+acc_id+'/portfolio/realize/'+ref+'/history?';
    let queryString = '';
    queryString += queryParamStr('size', size, true);
    queryString += queryParamStr('page', page);

    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});

    // console.log('fullUrl', fullUrl);
    // console.log(result);

    return parseResult(result);
};


export const getPortfolioUnrealized = async (acc_id = [], { stocks=[],exchanges =[], size = 10 }, page = 1) => {
     // let url = '/client/account/'+acc_id+'/portfolio/unrealize?';
//    let url = '/client/portfolio/unrealize?accounts[]=363';
    // let url = '/client/portfolio/unrealize?';

    let url = '/client/portfolio/unrealize?';


    let queryString = '';

    // console.log("stocks",stocks);
    //  console.log("exchanges",exchanges);

    queryString += queryParamStr('size', size, true);
    queryString += queryParamStr('page', page);

    if(stocks && stocks.length >0){
        queryString += queryParamStrArr('stocks[]', stocks);
    }

    
    if(exchanges && exchanges.length >0){
        queryString += queryParamStrArr('exchanges[]', exchanges);
    }
  

    if(acc_id && acc_id.length >0){
        queryString += queryParamStrArr('accounts[]', acc_id);
    }

   
    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});

    // console.log('fullUrl', fullUrl);
    // console.log(result);

    return parseResult(result);
};

export const getPortfolioUnrealizedHistory = async (acc_id = null,tid=null, { size = 10 }, page = 1) => {
    let url = '/client/account/'+acc_id+'/portfolio/unrealize/'+tid+'/history?';
    let queryString = '';
    queryString += queryParamStr('size', size, true);
    queryString += queryParamStr('page', page);

    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});

    // console.log('fullUrl', fullUrl);
    // console.log(result);

    return parseResult(result);
};

export const updatePortfolioUnrealizedHistoryPrice = async (acc_id = null,orderno=null, { price }:any) => {
    let url = '/client/account/'+acc_id+'/portfolio/unrealize/'+orderno;
  //  console.log("url",url);
    let result = await handleRequestPost(url, {
        "price": price,
        }
    );


    // console.log(result);

    return JSON.parse(result);
};
